import React, {Component, useState, useEffect} from 'react';
import AddressSearchBar from '../../addressSearchBar/js/AddressSearchBar.jsx';
import DirectionsModal from '../../directionModalBlock/js/DirectionModalBlock.jsx';
import queryString from 'global/js/query-string.js';
import {geocodeByAddress, getLatLng} from 'react-places-autocomplete';


const DirectionsBlock = (props) => {
	const [originPoint, setOriginPoint] = React.useState('');
	const [destinationPoint, setDestinationPoint] = React.useState('');
	const [origCoords, setOrigCoords] = React.useState(null);
	const [destinationCoords, setDestinationCoords] = React.useState(null);
	const [mapVisible, setMapVisible] = React.useState(false);

	React.useEffect(() => {
		// const query = queryString.parse(location.search);
		// setDestinationPoint(query.address || '');
		// setOriginPoint(query.startaddress || '');
		const searchLocation = queryString.parse(localStorage.getItem('searchLocation')) || {};
		const userLocation = queryString.parse(localStorage.getItem('userLocation')) || {};
		setDestinationPoint(searchLocation.address || '');
		setOriginPoint(userLocation.startaddress || '');
	}, []);

	React.useEffect(() => {
		// // AddressSearchBar does not get coords when initialized so I am taking ownership locally until its refactored
		// bloody babble hasn't been configured for async await  so using then 😡
			if (originPoint) {
				getLatLngFromAddress(originPoint).then((latLng) => setOrigCoords(latLng));
			}
			if (destinationPoint) {
				getLatLngFromAddress(destinationPoint).then((latLng) => setDestinationCoords(latLng));
			}
	}, [originPoint, destinationPoint]);

	function getLatLngFromAddress(address) {
		return new Promise((res, rej) =>{
			geocodeByAddress(address)
			.then((result) => getLatLng(result[0]))
			.then((latLng) => res(latLng))
			.catch((err) => rej(err));
		});
	}

	return (
		<React.Fragment>
			<DirectionsModal
				originPoint={originPoint}
				setOriginPoint={setOriginPoint}
				destinationPoint={destinationPoint}
				setDestinationPoint={setDestinationPoint}
				origCoords={origCoords}
				destinationCoords={destinationCoords}
				parkingCoords={{lat: props.parkingLat, lng: props.parkingLng}}
				parkingName={props.parkingName}
				mapVisible={mapVisible}
			/>
			<div className="addressSearchBar-react mb-4">
				<div className="directionsBlock-startingLocation search-field">
					<AddressSearchBar
						preventFetchingResults={false}
						useCurrentLocation={true}
						getAddress={originPoint}
						onSelect={setOriginPoint}
						queryToUpdate="startaddress"
						setUserLocation={setOrigCoords}
						country={props.country}
					/>
				</div>
			</div>
			<div className="separator-icon">
				<span className="sr-only">{props.title}</span>
			</div>
			<div className="addressSearchBar-react mb-4">
				<div className="directionsBlock-destination search-field">
					<AddressSearchBar
						preventFetchingResults={false}
						useCurrentLocation={false}
						getAddress={destinationPoint}
						onSelect={setDestinationPoint}
						setUserLocation={setDestinationCoords}
						country={props.country}
					/>
				</div>
			</div>
			<button
				className="directionsBlock-btn"
				data-toggle="modal"
				data-target="#directionModal"
				onClick={() => setMapVisible(true)}
			>
				{props.buttonText}
			</button>
		</React.Fragment>
	);
};

export default DirectionsBlock;
